import {
  Box,
  Card,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  Grid,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import {
  closeCustomModalDialog,
  openCustomModalDialog,
  setModalLoader,
} from "../../redux/slices/modalSlice";
import { useEffect, useState } from "react";
import { uploadImage } from "../../redux/slices/common";

export default function AddHomeBanner({ closeModal }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { modalData } = useSelector((state) => state.modal);
  const [errors, setErrors] = useState({});
  const [isUploading, setIsUploading] = useState(false);
  const [isUploading2, setIsUploading2] = useState(false);
  const validURL = (url) => {
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,})" + // domain name
      "(\\:\\d+)?" + // port
      "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
      "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment
      "i"
    );
    return !!urlPattern.test(url);
  };

  const initialState = {
    status: "active",
    destinationUrl: "",
    mediaType: "",
    desktop: {
      title: "",
      alt: "",
      description: "",
      imageFile: null,
    },
    mobile: {
      title: "",
      alt: "",
      description: "",
      imageFile: null,
    },
  };
  const [formData, setFormData] = useState(initialState);
  useEffect(() => {
    if (modalData?.bannerData) {
      setFormData((prev) => ({
        ...prev,
        ...modalData.bannerData,
      }));
    }
  }, [modalData?.bannerData]);

  const handleChange = (section, field, value) => {
    if (section) {
      setFormData((prev) => ({
        ...prev,
        [section]: { ...prev[section], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };
  const handleImageUpload = (section, file) => {
    setFormData((prev) => ({
      ...prev,
      [section]: { ...prev[section], imageFile: file },
    }));
  };

  const handleSubmit = () => {
    if (!validate()) return;
    setErrors({});
    if (modalData?.onSubmit) modalData?.onSubmit(formData);
    closeModal(); // close modal after sending data
  };
  const handleStatusChange = (status) => {
    setFormData((prev) => ({
      ...prev,
      status: status
    }));
  };
  const handleFileClick = (section) => {

    const inputId = section === "desktop" ? "desktop-file-input" : "mobile-file-input";
    document.getElementById(inputId).click();
  };

  const handleFileChange = async (event, section) => {
    const selectedFile = event.target.files?.[0];
    if (!selectedFile) return;
    if (section === "desktop") setIsUploading(true);
    else setIsUploading2(true);
    // Allow only images
    if (formData.mediaType === "video") {
      const allowedVideo = [".mp4", ".webm"];
      if (!allowedVideo.some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
        alert("Please upload a valid video file (.mp4 or .webm )");
        return;
      }
    }

    if (formData.mediaType === "image") {
      const allowedImg = [".jpg", ".jpeg", ".png", ".gif"];
      if (!allowedImg.some(ext => selectedFile.name.toLowerCase().endsWith(ext))) {
        alert("Please upload a valid image file (.jpg, .png, .gif)");
        return;
      }
    }
    const body = new FormData();
    body.append("filePath", selectedFile);

    try {
      dispatch(setModalLoader(true));

      const res = await dispatch(uploadImage(body)).unwrap();

      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          imageFile: res.fileUrl,
        },
      }));
    } catch (err) {
      alert("Image upload failed. Try again.");
    } finally {
      dispatch(setModalLoader(false));
      setIsUploading(false);
      setIsUploading2(false);
    }
  };

  const validate = () => {
    const temp = {};

    // Destination URL
    if (!formData.status) {
      temp.status = "Status is required"
    }
    if (!formData.destinationUrl) {
      temp.destinationUrl = "Destination URL is required";
    } else if (!validURL(formData.destinationUrl)) {
      temp.destinationUrl = "Please enter a valid URL";
    }
    if (!formData.mediaType) temp.mediaType = "Select a Media Type"
    // Desktop
    if (!formData.desktop.imageFile) temp.desktopImage = "Desktop image is required";
    if (!formData.desktop.title) temp.desktopTitle = "Title is required";
    if (!formData.desktop.alt) temp.desktopAlt = "Alt text is required";
    if (!formData.desktop.description) temp.deskDescription = "Description is required";

    // Mobile
    if (!formData.mobile.imageFile) temp.mobileImage = "Mobile image is required";
    if (!formData.mobile.title) temp.mobileTitle = "Title is required";
    if (!formData.mobile.alt) temp.mobileAlt = "Alt text is required";
    if (!formData.mobile.description) temp.mobDescription = "Description is required";

    setErrors(temp);

    // Return true if no errors
    return Object.keys(temp).length === 0;
  };
  return (
    <Card sx={{ py: 3, px: 4, borderRadius: 0 }}>
      <DialogTitle
        id="draggable-dialog-title"
        sx={{ p: 0, mb: 4 }}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box display="flex" alignItems="center" gap={2}>
          Add Banner
          <Stack
            direction="row"
            alignItems="center"
            gap={0.75}
            lineHeight={1}
            p={0.75}
            borderRadius={2}
            bgcolor="#F2F3F7"
            className="modal-add-banner-btns"
          >
            <MDButton
              sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
              type='button'
              onClick={() => setFormData({ ...formData, status: 'active' })}
              variant={formData?.status === 'active' ? 'contained' : 'text'}
              color={formData?.status === 'active' ? 'success' : 'dark'}
              size="small"
            >
              Active
            </MDButton>
            <MDButton
              sx={{ minWidth: '92px', borderRadius: 1.75, minHeight: '28px', p: .25, fontWeight: 500 }}
              type='button'
              onClick={() => setFormData({ ...formData, status: 'inactive' })}
              variant={formData?.status !== 'active' ? 'contained' : 'text'}
              color={formData?.status !== 'active' ? 'error' : 'dark'}
              size="small"
            >
              Inactive
            </MDButton>
          </Stack>
          {errors.status && (
            <Typography variant="body2" color="error" sx={{ mt: 1, ml: 1 }}>
              {errors.status}
            </Typography>
          )}
        </Box>
        <IconButton onClick={closeModal} edge="end" size="small" className="modal-close">
          <CloseIcon fontSize="medium" />
        </IconButton>
      </DialogTitle>

      <div style={{ paddingLeft: "0", paddingRight: "0" }}>
        <Grid container direction="row" spacing={2} mb={3}>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              fontWeight="medium"
              color="#9A9AAF"
              mb={1}
              style={{ fontSize: "14px" }}
            >
              Media Type
            </Typography>
            <FormControl fullWidth error={!!errors.mediaType}>
              {/* <InputLabel>Media Type 121</InputLabel> */}
              <Select
                // label="Media Type"
                placeholder="Media Type"
                value={formData.mediaType}
                onChange={(e) => {
                  setErrors((prev) => ({ ...prev, mediaType: "" }));
                  handleChange(null, "mediaType", e.target.value), setFormData(prev => ({
                    ...prev,
                    desktop: { ...prev.desktop, imageFile: null },
                    mobile: { ...prev.mobile, imageFile: null }
                  }));
                }}
                displayEmpty
              >
                <MenuItem value="image">Image</MenuItem>
                <MenuItem value="video">Video</MenuItem>
              </Select>
              {errors.mediaType && (
                <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                  {errors.mediaType}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              fontWeight="medium"
              color="#9A9AAF"
              mb={1}
              style={{ fontSize: "14px" }}
            >
              Destination URL
            </Typography>
            <TextField
              label=""
              className="form-input fs-14"
              fullWidth
              placeholder="http://example.com"
              value={formData.destinationUrl}
              error={!!errors.destinationUrl}
              helperText={errors.destinationUrl}
              onChange={(e) => {
                if (!formData.mediaType) {
                  setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                  return
                }
                setErrors((prev) => ({ ...prev, destinationUrl: "" }));
                handleChange(null, "destinationUrl", e.target.value);
              }}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="start" gap={3}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="20px"
                backgroundColor="#F1F1F1"
                width="190px"
                height="200px"
                sx={{
                  border: errors.desktopImage ? "1px solid red" : "none",
                }}
              >
                <input
                  type="file"
                  id="desktop-file-input"
                  style={{ display: "none" }}
                  accept={formData.mediaType === 'video' ? '.mp4,.webm' : '.png,.jpg,.jpeg,.gif,webp'}
                  onChange={(e) => {
                    setErrors((prev) => ({ ...prev, desktopImage: "" }));
                    handleFileChange(e, "desktop");
                  }}
                />
                <MDButton
                  sx={{ minWidth: "180px" }}
                  type="button"
                  variant="outlined"
                  color="secondary"
                  component="span"
                  onClick={() => {
                    if (!formData.mediaType) {
                      setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                      return
                    }

                    setErrors((prev) => ({ ...prev, desktopImage: "" }));
                    handleFileClick("desktop");
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "0",
                    border: "none",
                    borderRadius: "0",
                  }}
                >
                  <div className="add-change-img-sec" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", width: "100%", height: "100%" }}>
                    {isUploading ? (
                      <CircularProgress size={28} />
                    ) :

                      formData.desktop.imageFile ? (

                        // <Typography fontSize={12} fontWeight={500}>
                        //     {formData.desktop.imageFile.name}
                        // </Typography>

                        <Box style={{ width: "100%", height: "100%" }}>

                          {formData.mediaType === "image" ? (
                            <img
                              src={formData.desktop.imageFile}
                              alt="preview"
                              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "20px" }}
                            />
                          ) : (
                            <video
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                              loop
                              autoPlay
                              muted
                              playsInline
                            >
                              <source src={formData.desktop.imageFile} type="video/mp4" />
                              <source src={formData.desktop.imageFile} type="video/webm" />
                              <source src={formData.desktop.imageFile} type="video/.gif" />
                            </video>
                          )}
                          {/* <IconButton
                            className="remove-icon"
                            size="small"
                            onClick={(e) => {
                              setFormData((prev) => ({
                                ...prev,
                                desktop: { ...prev.desktop, imageFile: null },
                              }))

                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton> */}
                        </Box>
                      ) : (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="25"
                            viewBox="0 0 24 25"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_26193_49200)">
                              <path
                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                fill="#2E2E3A"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_26193_49200">
                                <rect width="24" height="25" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <Typography
                            variant="body2"
                            fontWeight="600"
                            color="#2E2E3A"
                            style={{ fontSize: "12px" }}
                          >
                            Desktop {formData.mediaType || "image"}
                          </Typography>
                          <Typography
                            variant="body2"
                            fontWeight="400"
                            color="#2E2E3A"
                            style={{ fontSize: "12px" }}
                          >
                            1252x560
                          </Typography>
                        </>
                      )}
                  </div>
                </MDButton>
              </Box>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    {formData.mediaType?.charAt(0).toUpperCase() + formData.mediaType?.slice(1) || "Image"} Title

                  </Typography>
                  <TextField
                    label=""
                    className="form-input fs-14"
                    fullWidth
                    placeholder="Title"
                    value={formData.desktop.title}
                    error={!!errors.desktopTitle}
                    helperText={errors.desktopTitle}
                    onChange={(e) => {
                      if (!formData.mediaType) {
                        setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                        return
                      }
                      setErrors((prev) => ({ ...prev, desktopTitle: "" }));
                      handleChange("desktop", "title", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Alt Text
                  </Typography>
                  <TextField
                    label=""
                    className="form-input fs-14"
                    fullWidth
                    placeholder="Image text"
                    value={formData.desktop.alt}
                    error={!!errors.desktopAlt}
                    helperText={errors.desktopAlt}
                    onChange={(e) => {
                      if (!formData.mediaType) {
                        setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                        return
                      }
                      setErrors((prev) => ({ ...prev, desktopAlt: "" }));
                      handleChange("desktop", "alt", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Description
                  </Typography>
                  <TextField
                    label=""
                    className="form-input fs-14"
                    fullWidth
                    placeholder="Description"
                    value={formData.desktop.description}
                    error={!!errors.deskDescription}
                    helperText={errors.deskDescription}
                    onChange={(e) => {
                      if (!formData.mediaType) {
                        setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                        return
                      }
                      setErrors((prev) => ({ ...prev, deskDescription: "" })); //deskDescription
                      handleChange("desktop", "description", e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" alignItems="start" gap={3}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="20px"
                backgroundColor="#F1F1F1"
                width="190px"
                height="200px"
                sx={{
                  border: errors.mobileImage ? "1px solid red" : "none",
                }}
              >
                <input
                  type="file"
                  id="mobile-file-input"
                  style={{ display: "none" }}
                  accept={formData?.mediaType === 'video' ? '.mp4,.webm' : '.png,.jpg,.jpeg,.gif'}
                  onChange={(e) => {
                    setErrors((prev) => ({ ...prev, mobileImage: "" }));
                    handleFileChange(e, "mobile");
                  }}
                />
                <MDButton
                  sx={{ minWidth: "180px" }}
                  type="button"
                  variant="outlined"
                  color="secondary"
                  component="span"
                  onClick={() => {
                    if (!formData.mediaType) {
                      setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                      return
                    }
                    setErrors((prev) => ({ ...prev, mobileImage: "" }));
                    handleFileClick("mobile");
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                    padding: "0",
                    border: "none",
                    borderRadius: "0",
                  }}
                >
                  <div className="add-change-img-sec" style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", width: "100%", height: "100%" }}>
                    {isUploading2 ? (
                      <CircularProgress size={28} />
                    ) : formData.mobile.imageFile ? (
                      <Box style={{ width: "100%", height: "100%" }}>
                        {/* <IconButton
                          className="remove-icon"
                          size="small"
                          onClick={(e) => {
                            setFormData((prev) => ({
                              ...prev,
                              desktop: { ...prev.desktop, imageFile: null },
                            }))

                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton> */}
                        {formData.mediaType === "image" ? (
                          <img
                            src={formData.mobile.imageFile}
                            alt="preview"
                            style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "20px" }}
                          />
                        ) : (
                          <video
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            loop
                            autoPlay
                            muted
                            playsInline
                          >
                            <source src={formData.mobile.imageFile} type="video/mp4" />
                            <source src={formData.mobile.imageFile} type="video/webm" />
                            <source src={formData.mobile.imageFile} type="video/gif" />
                          </video>
                        )
                        }
                      </Box>
                    ) : (
                      <>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_26193_49200)">
                            <path
                              d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                              fill="#2E2E3A"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_26193_49200">
                              <rect width="24" height="25" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <Typography
                          variant="body2"
                          fontWeight="600"
                          color="#2E2E3A"
                          style={{ fontSize: "12px" }}
                        >
                          Mobile {formData.mediaType || "image"}
                        </Typography>
                        <Typography
                          variant="body2"
                          fontWeight="400"
                          color="#2E2E3A"
                          style={{ fontSize: "12px" }}
                        >
                          406x180
                        </Typography>
                      </>
                    )}
                  </div>
                </MDButton>
              </Box>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    {formData.mediaType?.charAt(0).toUpperCase() + formData.mediaType?.slice(1) || "Image"} Title

                  </Typography>
                  <TextField
                    label=""
                    className="form-input fs-14"
                    fullWidth
                    placeholder="Title"
                    value={formData.mobile.title}
                    error={!!errors.mobileTitle}
                    helperText={errors.mobileTitle}
                    onChange={(e) => {
                      if (!formData.mediaType) {
                        setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                        return
                      }
                      setErrors((prev) => ({ ...prev, mobileTitle: "" }));
                      handleChange("mobile", "title", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Alt Text
                  </Typography>
                  <TextField
                    label=""
                    className="form-input fs-14"
                    fullWidth
                    placeholder="Alt text"
                    value={formData.mobile.alt}
                    error={!!errors.mobileAlt}
                    helperText={errors.mobileAlt}
                    onChange={(e) => {
                      if (!formData.mediaType) {
                        setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                        return
                      }
                      setErrors((prev) => ({ ...prev, mobileAlt: "" }));
                      handleChange("mobile", "alt", e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Description
                  </Typography>
                  <TextField
                    label=""
                    className="form-input fs-14"
                    fullWidth
                    placeholder="Description"
                    value={formData.mobile.description}
                    error={!!errors.mobDescription}
                    helperText={errors.mobDescription}
                    onChange={(e) => {
                      if (!formData.mediaType) {
                        setErrors((prev) => ({ ...prev, mediaType: "Select a Media Type" }))
                        return
                      }
                      setErrors((prev) => ({ ...prev, mobDescription: "" })); //mobDescription
                      handleChange("mobile", "description", e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.25} mt={4} pt={2} mb={1}>
          <MDButton
            sx={{ width: "150px" }}
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
          >
            {modalData.bannerData ? "Update" : "Add"}
          </MDButton>
          <MDButton
            sx={{ width: "150px" }}
            type="button"
            variant="outlined"
            color="dark"
            onClick={closeModal}
          >
            Cancel
          </MDButton>
        </Stack>
      </div>
    </Card >
  );
}
